import { render, staticRenderFns } from "./ConfigTsConfCom2ByMemberDivPopup.vue?vue&type=template&id=6bdede7f&"
import script from "./ConfigTsConfCom2ByMemberDivPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigTsConfCom2ByMemberDivPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports